import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import Logo from "../Images/Konn3ct Images/konn3ct_logo.png";

const Konn3ctHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const location = useLocation();
  const companyDropdownRef = useRef(null);

  // Close mobile menu when clicking a link
  const closeMobileMenu = () => setMenuOpen(false);

  // ---------- ACTIVE HELPERS ----------
  const isActive = (path) => location.pathname === path;

  const navItemClass = (path) =>
    `relative text-sm font-medium transition
     hover:text-[#1A4699]
     ${isActive(path) ? "text-[#1A4699] font-semibold" : "text-gray-800"}`;

  const activeUnderline =
    "after:absolute after:left-0 after:-bottom-1 after:w-full after:h-[2px] after:bg-[#1A4699]";

  const isCompanyActive = [
    "/AboutUs",
    "/BlogPage",
    "/Konn3ctDevs",
    "/Gallery",
  ].includes(location.pathname);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        companyDropdownRef.current &&
        !companyDropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    // Listen to clicks on the entire document
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
     
      <div className="flex justify-between items-center px-6 py-4 max-w-7xl mx-auto h-16">
        {/* LOGO */}
        <Link to="/" onClick={closeMobileMenu}>
          <img
            src={Logo}
            alt="Konn3ct Logo"
            className="h-8 w-auto cursor-pointer"
          />
        </Link>

        {/* DESKTOP MENU */}
        <nav className="hidden md:flex space-x-6 text-sm font-medium items-center">
         
          <Link
            to="/Meet"
            className={`${navItemClass("/Meet")} ${
              isActive("/Meet") ? activeUnderline : ""
            }`}
          >
            Meet
          </Link>
          <Link
            to="/Features"
            className={`${navItemClass("/Features")} ${
              isActive("/Features") ? activeUnderline : ""
            }`}
          >
            Features
          </Link>
          <Link
            to="/Customers"
            className={`${navItemClass("/Customers")} ${
              isActive("/Customers") ? activeUnderline : ""
            }`}
          >
            Customers
          </Link>
          <Link
            to="/Pricing"
            className={`${navItemClass("/Pricing")} ${
              isActive("/Pricing") ? activeUnderline : ""
            }`}
          >
            Pricing
          </Link>
          {/* <Link
            to="/Pricing"
            className="text-gray-800 hover:text-[#1A4699] transition"
          >
            Pricing
          </Link> */}

          {/* COMPANY DROPDOWN - CLICK TO OPEN (DESKTOP) */}

          <div className="relative" ref={companyDropdownRef}>
            {" "}
            {/* ← wrap here */}
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              // className="flex items-center gap-1 text-gray-800 hover:text-[#1A4699] transition font-medium"
              // aria-haspopup="true"
              // aria-expanded={dropdownOpen}

              className={`flex items-center gap-1 transition font-medium ${
                isCompanyActive
                  ? "text-[#1A4699] font-semibold"
                  : "text-gray-800 hover:text-[#1A4699]"
              }`}
            >
              Company
              <ChevronDown
                size={16}
                className={`transition-transform duration-200 ${
                  dropdownOpen ? "rotate-180" : ""
                }`}
              />
            </button>
            {/* Dropdown Menu */}
            {dropdownOpen && (
              <div className="absolute left-0 mt-2 w-52 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-50">
                <Link
                  to="/AboutUs"
                  onClick={() => {
                    setDropdownOpen(false);
                    closeMobileMenu();
                  }}
                  // className="block px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-[#1A4699] transition text-sm font-medium"

                  className={`block px-6 py-3 transition text-sm font-medium ${
                    isActive("/AboutUs")
                      ? "bg-blue-50 text-[#1A4699]"
                      : "text-gray-700 hover:bg-blue-50 hover:text-[#1A4699]"
                  }`}
                >
                  About Us
                </Link>

                <Link
                  to="/BlogPage"
                  onClick={() => {
                    setDropdownOpen(false);
                    closeMobileMenu();
                  }}
                  // className="block px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-[#1A4699] transition text-sm font-medium"
                  className={`block px-6 py-3 transition text-sm font-medium ${
                    isActive("/BlogPage")
                      ? "bg-blue-50 text-[#1A4699]"
                      : "text-gray-700 hover:bg-blue-50 hover:text-[#1A4699]"
                  }`}
                >
                  Blog
                </Link>

                <Link
                  to="/Konn3ctDevs"
                  onClick={() => {
                    setDropdownOpen(false);
                    closeMobileMenu();
                  }}
                  // className="block px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-[#1A4699] transition text-sm font-medium"
                  className={`block px-6 py-3 transition text-sm font-medium ${
                    isActive("/Konn3ctDevs")
                      ? "bg-blue-50 text-[#1A4699]"
                      : "text-gray-700 hover:bg-blue-50 hover:text-[#1A4699]"
                  }`}
                >
                  Developers
                </Link>

                <Link
                  to="/Gallery"
                  onClick={() => {
                    setDropdownOpen(false);
                    closeMobileMenu();
                  }}
                  // className="block px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-[#1A4699] transition text-sm font-medium"
                  className={`block px-6 py-3 transition text-sm font-medium ${
                    isActive("/Gallery")
                      ? "bg-blue-50 text-[#1A4699]"
                      : "text-gray-700 hover:bg-blue-50 hover:text-[#1A4699]"
                  }`}
                >
                  Gallery
                </Link>

                {/* <Link
                  to="/Konn3ctTC"
                  onClick={() => {
                    setDropdownOpen(false);
                    closeMobileMenu();
                  }}
                  className="block px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-[#1A4699] transition text-sm font-medium"
                >
                  Terms & Conditions
                </Link> */}
              </div>
            )}
          </div>

          <Link
            to="/EventsPage"
            className={`${navItemClass("/EventsPage")} ${
              isActive("/EventsPage") ? activeUnderline : ""
            }`}

            // className={navClass("/EventsPage")}
            // className="text-gray-800 hover:text-[#1A4699] transition"
          >
            Events
          </Link>
        </nav>

        {/* DESKTOP AUTH BUTTONS */}

        

        <div className="hidden md:flex space-x-3">

           
          
          <Link
            to="https://dashboard.konn3ct.com/join"
            className="px-4 py-2 text-sm text-[#1A4699] hover:text-blue-500"
          >
            Join a Meeting Room
          </Link>

          <button
            onClick={() =>
              (window.location.href = "https://www.newwavesecosystem.com/appointment/6?staff_user_id=32&invite_token=96ed5857091e47bdbded299526f2d5de&filter_appointment_type_ids=%5B6%5D")
            }
            className="px-4 py-2 text-sm text-white bg-blue-500 rounded-lg hover:bg-[#1A4699] transition shadow-sm"
          >
           Book a session
          </button>

          <button
            onClick={() =>
              (window.location.href = "https://dashboard.konn3ct.com/login")
            }
            className="px-4 py-2 text-sm bg-transparent border border-[#1A4699] rounded-lg text-black hover:text-blue-500 transition shadow-sm"
          >
            Login
          </button>
          <button
            onClick={() =>
              (window.location.href = "https://dashboard.konn3ct.com/register")
            }
            className="px-4 py-2 text-sm text-white bg-[#1A4699] rounded-lg hover:bg-blue-500 transition shadow-sm"
          >
            Sign up, It’s Free
          </button>
        </div>

        {/* MOBILE HAMBURGER */}
        <button
          className="md:hidden focus:outline-none text-gray-800"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <X size={28} /> : <Menu size={26} />}
        </button>
      </div>

      {/* MOBILE MENU - Also uses click for Company */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg px-6 py-6 space-y-4">
          <Link
            to="/Meet"
            onClick={closeMobileMenu}
            //   className="block text-lg font-medium text-gray-800 hover:text-[#1A4699]"
            // >

            className={`block text-lg font-medium transition
                ${
                  isActive("/Meet")
                    ? "text-[#1A4699]"
                    : "text-gray-800 hover:text-[#1A4699]"
                }`}
          >
            Meet
          </Link>
          <Link
            to="/Features"
            onClick={closeMobileMenu}
            className={`block text-lg font-medium transition
                ${
                  isActive("/Features")
                    ? "text-[#1A4699]"
                    : "text-gray-800 hover:text-[#1A4699]"
                }`}
          >
            Features
          </Link>
          <Link
            to="/Customers"
            onClick={closeMobileMenu}
            className={`block text-lg font-medium transition
                ${
                  isActive("/Customers")
                    ? "text-[#1A4699]"
                    : "text-gray-800 hover:text-[#1A4699]"
                }`}
          >
            Customers
          </Link>
          <Link
            to="/Pricing"
            onClick={closeMobileMenu}
            className={`block text-lg font-medium transition
                ${
                  isActive("/Pricing")
                    ? "text-[#1A4699]"
                    : "text-gray-800 hover:text-[#1A4699]"
                }`}
          >
            Pricing
          </Link>
          <Link
            to="/EventsPage"
            onClick={closeMobileMenu}
            className={`block text-lg font-medium transition
                ${
                  isActive("/EventsPage")
                    ? "text-[#1A4699]"
                    : "text-gray-800 hover:text-[#1A4699]"
                }`}
          >
            Events
          </Link>

          {/* Mobile Company Section */}
          {/* <div className="pt-4 border-t border-gray-200">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="w-full flex justify-between items-center text-lg font-medium text-gray-800 hover:text-[#1A4699]"
            >
              Company
              <ChevronDown
                className={`transition-transform ${
                  dropdownOpen ? "rotate-180" : ""
                }`}
              />
            </button> */}

          <div
            className="pt-4 border-t border-gray-200"
            ref={companyDropdownRef}
          >
            {" "}
            {/* ← wrap mobile too */}
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="w-full flex justify-between items-center text-lg font-medium text-gray-800 hover:text-[#1A4699]"
              aria-haspopup="true"
              aria-expanded={dropdownOpen}
            >
              Company
              <ChevronDown
                className={`transition-transform ${
                  dropdownOpen ? "rotate-180" : ""
                }`}
              />
            </button>
            {dropdownOpen && (
              <div classname="mt-3 space-y-2 pl-4">
                <Link
                  to="/AboutUs"
                  onClick={closeMobileMenu}
                  className="block py-2 text-gray-600 hover:text-[#1A4699]"
                >
                  About Us
                </Link>
                <Link
                  to="/BlogPage"
                  onClick={closeMobileMenu}
                  className="block py-2 text-gray-600 hover:text-[#1A4699]"
                >
                  Blog
                </Link>
                <Link
                  to="/Konn3ctDevs"
                  onClick={closeMobileMenu}
                  className="block py-2 text-gray-600 hover:text-[#1A4699]"
                >
                  Developers
                </Link>
                <Link
                  to="/Gallery"
                  onClick={closeMobileMenu}
                  className="block py-2 text-gray-600 hover:text-[#1A4699]"
                >
                  Gallery
                </Link>

                {/* <Link
                  to="/Konn3ctTC"
                  onClick={closeMobileMenu}
                  className="block py-2 text-gray-600 hover:text-[#1A4699]"
                >
                  Terms & Conditions
                </Link> */}
              </div>
            )}
          </div>

          {/* Mobile Auth Buttons */}

          <div className="pt-3 border-t border-gray-200 flex flex-col gap-2">
            <Link
              to="https://dashboard.konn3ct.com/join"
              className="w-full text-center py-2 text-lg text-blue-500"
            >
              Join a Meeting Room
            </Link>

            <div className="pt-1 border-gray-200 flex gap-2">
              <button
                onClick={() =>
                  (window.location.href = "https://dashboard.konn3ct.com/login")
                }
                className="w-1/3 py-2 text-sm border text-black border-[#1A4699] rounded-lg hover:text-blue-500"
              >
                Login
              </button>
              <button
                onClick={() =>
                  (window.location.href =
                    "https://dashboard.konn3ct.com/register")
                }
                className="w-2/3 py-2 text-sm text-white bg-[#1A4699] rounded-lg hover:bg-blue-500"
              >
                Sign up, It’s Free
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Konn3ctHeader;

// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { Menu, X, ChevronDown } from "lucide-react";
// import Logo from "../Images/Konn3ct Images/konn3ct_logo.png";

// const Konn3ctHeader = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);

//   return (
//     <header className="relative z-50 bg-white border-b border-gray-200 shadow-sm">
//       <div className="flex justify-between items-center px-6 py-4 max-w-7xl mx-auto">
//         {/* LOGO */}
//         <Link to="/" onClick={() => setMenuOpen(false)}>
//           <img
//             src={Logo}
//             alt="Konn3ct Logo"
//             className="h-8 w-auto cursor-pointer"
//           />
//         </Link>

//         {/* DESKTOP MENU */}
//         <nav className="hidden md:flex space-x-6 text-sm font-medium items-center">
//           <Link to="/Meet" className="text-black hover:text-blue-500">
//             Meet
//           </Link>
//           <Link to="/Features" className="text-black hover:text-blue-500">
//             Features
//           </Link>
//           <Link to="/Customers" className="text-black hover:text-blue-500">
//             Customers
//           </Link>
//           <Link to="/Pricing" className="text-black hover:text-blue-500">
//             Pricing
//           </Link>

//           {/* COMPANY DROPDOWN (DESKTOP) */}
//           <div
//             className="relative"
//             onMouseEnter={() => setDropdownOpen(true)}
//             onMouseLeave={() => setDropdownOpen(false)}
//           >
//             <button className="flex items-center gap-1 text-black hover:text-blue-500">
//               Company <ChevronDown size={16} className="mt-[1px]" />
//             </button>

//             {dropdownOpen && (
//               <div className="absolute left-0 mt-2 w-44 bg-white text-black rounded-md shadow-lg border border-gray-100 py-2">
//                 <Link
//                   to="/AboutUs"
//                   className="block px-4 py-2 hover:bg-gray-100"
//                 >
//                   About Us
//                 </Link>
//                 <Link
//                   to="/Konn3ctDevs"
//                   className="block px-4 py-2 hover:bg-gray-100"
//                 >
//                   Developers
//                 </Link>
//                 <Link
//                   to="/Konn3ctTC"
//                   className="block px-4 py-2 hover:bg-gray-100"
//                 >
//                   Terms & Conditions
//                 </Link>
//               </div>
//             )}
//           </div>
//           <Link to="/EventsPage" className="text-black hover:text-blue-500">
//             Events
//           </Link>
//         </nav>

//         {/* DESKTOP AUTH BUTTONS */}
//         <div className="hidden md:flex space-x-3">
//           <Link
//             to="https://dashboard.konn3ct.com/join"
//             className="px-4 py-2 text-sm text-[#1A4699] hover:text-blue-500"
//           >
//             Join a Meeting Room
//           </Link>
//           <button
//             onClick={() =>
//               (window.location.href = "https://dashboard.konn3ct.com/login")
//             }
//             className="px-4 py-2 text-sm bg-transparent border border-[#1A4699] rounded-lg text-black hover:text-blue-500 transition shadow-sm"
//           >
//             Login
//           </button>
//           <button
//             onClick={() =>
//               (window.location.href = "https://dashboard.konn3ct.com/register")
//             }
//             className="px-4 py-2 text-sm text-white bg-[#1A4699] rounded-lg hover:bg-blue-500 transition shadow-sm"
//           >
//             Sign up, It’s Free
//           </button>

//           {/* <button className="px-4 py-2 text-sm text-white bg-[#1A4699] rounded-lg hover:bg-blue-500 transition shadow-sm">
//              Join a Meeting Room
//           </button> */}
//         </div>

//         {/*✅ Hamburger Icon (Mobile) */}
//         <button
//           className="md:hidden focus:outline-none text-black"
//           onClick={() => setMenuOpen(!menuOpen)}
//         >
//           {menuOpen ? <X size={26} /> : <Menu size={26} />}
//         </button>
//       </div>

//       {/* MOBILE MENU */}
//       {menuOpen && (
//         <div className="md:hidden bg-white border-t shadow-lg px-6 py-4 space-y-3 animate-fadeIn">
//           <Link
//             to="/Meet"
//             onClick={() => setMenuOpen(false)}
//             className="block text-black hover:text-blue-500"
//           >
//             Meet
//           </Link>
//           <Link
//             to="/Features"
//             onClick={() => setMenuOpen(false)}
//             className="block text-black hover:text-blue-500"
//           >
//             Features
//           </Link>
//           <Link
//             to="/Customers"
//             onClick={() => setMenuOpen(false)}
//             className="block text-black hover:text-blue-500"
//           >
//             Customers
//           </Link>
//           <Link
//             to="/Pricing"
//             onClick={() => setMenuOpen(false)}
//             className="block text-black hover:text-blue-500"
//           >
//             Pricing
//           </Link>
//           <Link
//             to="/EventsPage"
//             onClick={() => setMenuOpen(false)}
//             className="block text-black hover:text-blue-500"
//           >
//             Events
//           </Link>

//           {/* MOBILE DROPDOWN LINKS */}
//           <hr className="border-gray-200" />

//           <Link
//             to="/AboutUs"
//             onClick={() => setMenuOpen(false)}
//             className="block text-black hover:text-blue-500"
//           >
//             About Us
//           </Link>
//           <Link
//             to="/Konn3ctDevs"
//             onClick={() => setMenuOpen(false)}
//             className="block text-black hover:text-blue-500"
//           >
//             Developers
//           </Link>
//           <Link
//             to="/Konn3ctTC"
//             onClick={() => setMenuOpen(false)}
//             className="block text-black hover:text-blue-500"
//           >
//             Terms & Conditions
//           </Link>

//           <div className="pt-3 border-t border-gray-200 flex gap-2">
//             <button className="w-1/3 py-2 text-sm border text-black border-[#1A4699] rounded-lg hover:text-blue-500">
//               Login
//             </button>
//             <button className="w-2/3 py-2 text-sm text-white bg-[#1A4699] rounded-lg hover:bg-blue-500">
//               Sign up, It’s Free
//             </button>
//           </div>
//         </div>
//       )}
//     </header>
//   );
// };

// export default Konn3ctHeader;

// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { Menu, X, ChevronDown } from "lucide-react";
// import Logo from "../Images/Konn3ct Images/konn3ct_logo.png";

// const Konn3ctHeader = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);

//   const toggleMenu = () => setMenuOpen(!menuOpen);
//   const closeMenu = () => setMenuOpen(false);

//   const openDropdown = () => setDropdownOpen(true);
//   const closeDropdown = () => setDropdownOpen(false);

//   return (
//     <header className="relative z-50 bg-white border-b border-gray-200 shadow-sm">
//       <div className="flex justify-between items-center px-6 py-4 max-w-7xl mx-auto">
//         {/* ✅ Logo */}
//         <Link to="/" onClick={closeMenu}>
//           <img
//             src={Logo}
//             alt="Konn3ct Logo"
//             className="h-8 w-auto cursor-pointer"
//           />
//         </Link>

//         {/* ✅ Desktop Navigation */}
//         <nav className="hidden md:flex space-x-6 text-sm font-medium items-center">
//           <Link to="/Meet" className="text-black hover:text-blue-500">
//             Meet
//           </Link>
//           <Link to="/Features" className="text-black hover:text-blue-500">
//             Features
//           </Link>
//           <Link to="/Customers" className="text-black hover:text-blue-500">
//             Customers
//           </Link>
//           <Link to="/Pricing" className="text-black hover:text-blue-500">
//             Pricing
//           </Link>

//           {/* ✅ Dropdown */}
//           <div
//             className="relative"
//             onMouseEnter={openDropdown}
//             onMouseLeave={closeDropdown}
//           >
//             <button
//               className="flex items-center gap-1 text-black hover:text-blue-500 focus:outline-none"
//             >
//               Company <ChevronDown size={16} className="mt-[1px]" /> {/* ✅ Replaced ▼ */}
//             </button>

//             {dropdownOpen && (
//               <div
//                 className="absolute left-0 mt-2 w-44 bg-white text-black rounded-md shadow-lg border border-gray-100 py-2"
//                 onMouseEnter={openDropdown}
//                 onMouseLeave={closeDropdown}
//               >
//                 <Link
//                   to="/AboutUs"
//                   className="block px-4 py-2 hover:bg-gray-100"
//                 >
//                   About Us
//                 </Link>
//                 <Link
//                   to="/Konn3ctDevs"
//                   className="block px-4 py-2 hover:bg-gray-100"
//                 >
//                   Developers
//                 </Link>

//                 <Link
//                   to="/Konn3ctTC"
//                   className="block px-4 py-2 hover:bg-gray-100"
//                 >
//                   Terms & Conditions
//                 </Link>
//               </div>

//             )}
//           </div>
//            <Link to="/EventsPage" className="text-black hover:text-blue-500">
//            Events
//           </Link>
//         </nav>

//         {/* ✅ Desktop Auth Buttons */}
//         <div className="hidden md:flex space-x-3">
//           <button className="px-4 py-2 text-sm bg-transparent border border-[#1A4699] rounded-lg text-black hover:bg-white hover:text-blue-500 transition shadow-sm">
//             Login
//           </button>
//           <button className="px-4 py-2 text-sm text-white bg-[#1A4699] rounded-lg hover:bg-blue-500 transition shadow-sm">
//             Sign up, It’s Free
//           </button>
//         </div>

//         {/* ✅ Hamburger Icon (Mobile) */}
//         <button
//           className="md:hidden focus:outline-none text-black"
//           onClick={toggleMenu}
//         >
//           {menuOpen ? <X size={26} /> : <Menu size={26} />}
//         </button>
//       </div>

//       {/* ✅ Mobile Menu */}
//       {menuOpen && (
//         <div className="md:hidden bg-white border-t border-gray-200 shadow-lg px-6 py-4 space-y-3">
//           <Link
//             to="/Meet"
//             onClick={closeMenu}
//             className="block text-black hover:text-blue-500"
//           >
//             Meet
//           </Link>
//           <Link
//             to="/Features"
//             onClick={closeMenu}
//             className="block text-black hover:text-blue-500"
//           >
//             Features
//           </Link>
//           <Link
//             to="/Customers"
//             onClick={closeMenu}
//             className="block text-black hover:text-blue-500"
//           >
//             Customers
//           </Link>
//           <Link
//             to="/Pricing"
//             onClick={closeMenu}
//             className="block text-black hover:text-blue-500"
//           >
//             Pricing
//           </Link>

//            <Link
//             to="/EventsPage"
//             onClick={closeMenu}
//             className="block text-black hover:text-blue-500"
//           >
//            Events
//           </Link>

//           <hr className="border-gray-200" />

//           <Link
//             to="/AboutUs"
//             onClick={closeMenu}
//             className="block text-black hover:text-blue-500"
//           >
//             About Us
//           </Link>
//           <Link
//             to="/Konn3ctDevs"
//             onClick={closeMenu}
//             className="block text-black hover:text-blue-500"
//           >
//             Developers
//           </Link>
//           <Link
//             to="/Konn3ctTC"
//             onClick={closeMenu}
//             className="block text-black hover:text-blue-500"
//           >
//             Terms & Conditions
//           </Link>

//           <div className=" pt-3 border-t border-gray-200 flex flex-row sm:flex-row gap-2">
//             <button className="w-1/3 flex-1 py-2 text-sm bg-transparent border border-[#1A4699] rounded-lg text-black hover:text-blue-500 transition shadow-sm">
//               Login
//             </button>
//             <button className="w-2/3 flex-1 py-2 text-sm text-white bg-[#1A4699] rounded-lg hover:bg-blue-500 transition shadow-sm">
//               Sign up, It’s Free
//             </button>
//           </div>
//         </div>
//       )}
//     </header>
//   );
// };

// export default Konn3ctHeader;

// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { Menu, X } from "lucide-react";
// import Logo from "../Images/Konn3ct Images/konn3ct_logo.png";

// const Konn3ctHeader = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);

//   const toggleMenu = () => setMenuOpen(!menuOpen);
//   const closeMenu = () => setMenuOpen(false);

//   const openDropdown = () => setDropdownOpen(true);
//   const closeDropdown = () => setDropdownOpen(false);

//   return (
//     <header className="relative z-50 bg-white border-b border-gray-200">
//       <div className="flex justify-between items-center px-6 py-4">
//         {/* Logo */}
//         <Link to="/" onClick={closeMenu}>
//           <img src={Logo} alt="Konnect Logo" className="h-8 w-auto cursor-pointer" />
//         </Link>

//         {/* Desktop Navigation */}
//         <nav className="hidden md:flex space-x-6 text-sm font-medium relative">
//           <Link to="/Meet" className="text-black hover:text-blue-500">
//             Meet

//           </Link>
//           <Link to="/Features" className="text-black hover:text-blue-500">
//             Features
//           </Link>
//           <Link to="/Customers" className="text-black hover:text-blue-500">
//             Customers
//           </Link>
//           <Link to="/Pricing" className="text-black hover:text-blue-500">
//             Pricing
//           </Link>

//           {/* Dropdown with hover fix */}
//           <div
//             className="relative"
//             onMouseEnter={openDropdown}
//             onMouseLeave={closeDropdown}
//           >
//             <Link
//               className="flex items-center gap-1 text-black hover:text-blue-500 focus:outline-none"
//             >
//               Company
//               <span className="text-xs">▼</span>
//             </Link>

//             {dropdownOpen && (
//               <div
//                 className="absolute left-0 mt-2 w-44 bg-white text-black rounded-md shadow-lg border border-gray-100 py-2"
//                 onMouseEnter={openDropdown}
//                 onMouseLeave={closeDropdown}
//               >
//                 <Link
//                   to="/AboutUs"
//                   className="block px-4 py-2 hover:bg-gray-100"
//                 >
//                   About Us
//                 </Link>
//                 <Link
//                   to="/ChangeLog"
//                   className="block px-4 py-2 hover:bg-gray-100"
//                 >
//                   Changelog
//                 </Link>
//                 <Link
//                   to="/Konn3ctTC"
//                   className="block px-4 py-2 hover:bg-gray-100"
//                 >
//                   Terms & Conditions
//                 </Link>
//               </div>
//             )}
//           </div>
//         </nav>

//         {/* Auth Buttons (Desktop) */}
//         <div className="hidden md:flex space-x-3">
//           <button className="px-4 py-2 text-sm bg-transparent border border-[#1A4699] rounded-lg text-black hover:bg-white hover:text-blue-400 transition shadow-md">
//             Login
//           </button>
//           <button className="px-4 py-2 text-sm text-white bg-blue-500 rounded-lg hover:bg-[#1A4699] transition">
//             Sign up, It’s Free
//           </button>
//         </div>

//         {/* Hamburger Icon (Mobile) */}
//         <button
//           className="md:hidden focus:outline-none text-black"
//           onClick={toggleMenu}
//         >
//           {menuOpen ? <X size={26} /> : <Menu size={26} />}
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       {menuOpen && (
//         <div className="md:hidden bg-white border-t border-gray-200 shadow-lg px-6 py-4 space-y-3">
//           <Link to="/Meet" onClick={closeMenu} className="block text-black hover:text-blue-500">
//             Meet
//           </Link>
//           <Link to="/Features" onClick={closeMenu} className="block text-black hover:text-blue-500">
//             Features
//           </Link>
//           <Link to="/Customers" onClick={closeMenu} className="block text-black hover:text-blue-500">
//             Customers
//           </Link>
//           <Link to="/Pricing" onClick={closeMenu} className="block text-black hover:text-blue-500">
//             Pricing
//           </Link>
//           <hr className="border-gray-200" />
//           <Link to="/AboutUs" onClick={closeMenu} className="block text-black hover:text-blue-500">
//             About Us
//           </Link>
//           <Link to="/ChangeLog" onClick={closeMenu} className="block text-black hover:text-blue-500">
//             Changelog
//           </Link>
//           <Link to="/Konn3ctTC" onClick={closeMenu} className="block text-black hover:text-blue-500">
//             Terms & Conditions
//           </Link>
//           <div className="pt-3 border-t border-gray-200 space-y-2 space-x-2">
//             <button className="w-1/3 py-2 text-sm bg-transparent border border-[#1A4699] rounded-lg text-black hover:text-blue-400 transition shadow-sm">
//               Login
//             </button>
//             <button className="w-1/3 py-2 text-sm text-white bg-blue-500 rounded-lg hover:bg-[#1A4699] transition">
//               Sign up, It’s Free
//             </button>
//           </div>
//         </div>
//       )}
//     </header>
//   );
// };

// export default Konn3ctHeader;

// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { Menu, X } from "lucide-react"; // For hamburger and close icons
// import Logo from "../Images/Konn3ct Images/konn3ct_logo.png";

// const Konn3ctHeader = () => {
//   const [menuOpen, setMenuOpen] = useState(false);

//   const toggleMenu = () => setMenuOpen(!menuOpen);
//   const closeMenu = () => setMenuOpen(false);

//   return (
//     <header className="relative z-50 bg-white border-b border-gray-200">
//       <div className="flex justify-between items-center px-6 py-4">
//         {/* Logo */}
//         <Link to="/" onClick={closeMenu}>
//           <img
//             src={Logo}
//             alt="Konnect Logo"
//             className="h-8 w-auto cursor-pointer"
//           />
//         </Link>

//         {/* Desktop Navigation */}
//         <nav className="hidden md:flex space-x-6 text-sm font-medium">
//           <Link to="/Meet" className="text-black hover:text-blue-500">
//             Meet
//           </Link>
//           <Link to="/Features" className="text-black hover:text-blue-500">
//             Features
//           </Link>
//           <Link to="/Customers" className="text-black hover:text-blue-500">
//             Customers
//           </Link>
//           <Link to="/Pricing" className="text-black hover:text-blue-500">
//             Pricing
//           </Link>

//           {/* Dropdown */}
//           <div className="group relative">
//             <button className="flex items-center gap-1 text-black hover:text-blue-500">
//               Company
//               <span className="text-xs">▼</span>
//             </button>
//             <div className="absolute left-0 mt-2 w-44 bg-white text-black rounded-md shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition">
//               <Link
//                 to="/AboutUs"
//                 className="block px-4 py-2 hover:bg-gray-100"
//               >
//                 About Us
//               </Link>
//               <Link
//                 to="/ChangeLog"
//                 className="block px-4 py-2 hover:bg-gray-100"
//               >
//                 Changelog
//               </Link>
//               <Link
//                 to="/Konn3ctTC"
//                 className="block px-4 py-2 hover:bg-gray-100"
//               >
//                 Terms & Conditions
//               </Link>
//             </div>
//           </div>
//         </nav>

//         {/* Auth Buttons (Desktop) */}
//         <div className="hidden md:flex space-x-3">
//           <button className="px-4 py-2 text-sm bg-transparent border border-[#1A4699] rounded-lg text-black hover:bg-white hover:text-blue-400 transition shadow-md">
//             Login
//           </button>
//           <button className="px-4 py-2 text-sm text-white bg-blue-500 rounded-lg hover:bg-[#1A4699] transition">
//             Sign up, It’s Free
//           </button>
//         </div>

//         {/* Hamburger Icon (Mobile) */}
//         <button
//           className="md:hidden focus:outline-none text-black"
//           onClick={toggleMenu}
//         >
//           {menuOpen ? <X size={26} /> : <Menu size={26} />}
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       {menuOpen && (
//         <div className="md:hidden bg-white border-t border-gray-200 shadow-lg px-6 py-4 space-y-3">
//           <Link
//             to="/Meet"
//             onClick={closeMenu}
//             className="block text-black hover:text-blue-500"
//           >
//             Meet
//           </Link>
//           <Link
//             to="/Features"
//             onClick={closeMenu}
//             className="block text-black hover:text-blue-500"
//           >
//             Features
//           </Link>
//           <Link
//             to="/Customers"
//             onClick={closeMenu}
//             className="block text-black hover:text-blue-500"
//           >
//             Customers
//           </Link>
//           <Link
//             to="/Pricing"
//             onClick={closeMenu}
//             className="block text-black hover:text-blue-500"
//           >
//             Pricing
//           </Link>
//           <hr className="border-gray-200" />
//           <Link
//             to="/AboutUs"
//             onClick={closeMenu}
//             className="block text-black hover:text-blue-500"
//           >
//             About Us
//           </Link>
//           <Link
//             to="/ChangeLog"
//             onClick={closeMenu}
//             className="block text-black hover:text-blue-500"
//           >
//             Changelog
//           </Link>
//           <Link
//             to="/Konn3ctTC"
//             onClick={closeMenu}
//             className="block text-black hover:text-blue-500"
//           >
//             Terms & Conditions
//           </Link>
//           <div className="pt-3 border-t border-gray-200 space-y-2 space-x-2">
//             <button className="w-1/3 py-2 text-sm bg-transparent border border-[#1A4699] rounded-lg text-black hover:text-blue-400 transition shadow-sm">
//               Login
//             </button>
//             <button className="w-1/2 py-2 text-sm text-white bg-blue-500 rounded-lg hover:bg-[#1A4699] transition">
//               Sign up, It’s Free
//             </button>
//           </div>
//         </div>
//       )}
//     </header>
//   );
// };

// export default Konn3ctHeader;

// import React from "react";
// import { Link } from "react-router-dom";
// import Logo from "../Images/Konn3ct Images/konn3ct_logo.png";

// const Konn3ctHeader = () => {
//   return (
//     <header className="relative z-10 flex justify-between bg-white items-center px-8 py-4 border-b border-t border-gray-200">
//       {/* Logo */}
//       <Link to="/">
//         <img src={Logo} alt="Konnect Logo" className="h-8 w-auto cursor-pointer" />
//       </Link>

//       {/* Navigation Links */}
//       <nav className="hidden md:flex space-x-6 text-sm font-medium">
//         <Link to="/Meet" className="text-black hover:text-blue-400">
//           Meet
//         </Link>
//         <Link to="/Features" className="text-black hover:text-blue-400">
//           Features
//         </Link>
//         <Link to="/Customers" className="text-black hover:text-blue-400">
//           Customers
//         </Link>
//         <Link to="/Pricing" className="text-black hover:text-blue-400">
//           Pricing
//         </Link>

//         {/* Company Dropdown */}
//         <div className="group relative">
//           <button className="flex items-center gap-1 text-black hover:text-blue-400">
//             Company
//             <span className="text-xs">▼</span>
//           </button>
//           <div className="absolute left-0 mt-2 w-40 bg-white text-black rounded-md shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition">
//             <Link
//               to="/AboutUs"
//               className="block px-4 py-2 hover:bg-gray-100"
//             >
//               About Us
//             </Link>
//             <Link
//               to="/ChangeLog"
//               className="block px-4 py-2 hover:bg-gray-100"
//             >
//               Changelog
//             </Link>
//             <Link
//               to="/Konn3ctTC"
//               className="block px-4 py-2 hover:bg-gray-100"
//             >
//               Terms & Conditions
//             </Link>
//           </div>
//         </div>
//       </nav>

//       {/* Auth Buttons */}
//       <div className="flex space-x-3">
//         <button className="px-4 py-2 text-sm bg-transparent border border-[#1A4699] rounded-lg text-black hover:bg-white hover:text-blue-400 transition shadow-lg">
//           Login
//         </button>
//         <button className="px-4 py-2 text-sm text-white bg-blue-500 rounded-lg hover:bg-[#1A4699] transition">
//           Sign up, It’s Free
//         </button>
//       </div>
//     </header>
//   );
// };

// export default Konn3ctHeader;

// import React from "react";
// import Logo from "../Images/Konn3ct Images/konn3ct_logo.png";

// const Konn3ctHeader = () => {
//   return (
//    <header className="relative z-10 flex justify-between bg-white items-center px-8 py-4 border-b border-t border-gray-200">
//         <img src={Logo} alt="Konnect Logo" className="h-8 w-auto" />
//         <nav className="hidden md:flex space-x-6 text-sm font-medium">
//           <a href="#" className="text-black hover:text-blue-400">
//             Meet
//           </a>
//           <a href="#" className="text-black hover:text-blue-400">
//             Features
//           </a>
//           <a href="#" className="text-black hover:text-blue-400">
//             Customers
//           </a>
//           <a href="#" className="text-black hover:text-blue-400">
//             Pricing
//           </a>
//           <div className="group relative">
//             <button className="flex items-center gap-1 text-black hover:text-blue-400">
//               Company
//               <span className="text-xs">▼</span>
//             </button>
//             <div className="absolute left-0 mt-2 w-40 bg-white text-black rounded-md shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition">
//               <a href="#" className="block px-4 py-2 hover:bg-gray-100">
//                 About Us
//               </a>
//               <a href="#" className="block px-4 py-2 hover:bg-gray-100">
//                 Careers
//               </a>
//               <a href="#" className="block px-4 py-2 hover:bg-gray-100">
//                 Contact
//               </a>
//             </div>
//           </div>
//         </nav>

//         <div className="flex space-x-3">
//           <button className="px-4 py-2 text-sm bg-transparent border border-[#1A4699] rounded-lg text-black hover:bg-white  hover:text-blue-400 transition shadow-lg">
//             Login
//           </button>
//           <button className="px-4 py-2 text-sm text-white bg-blue-500 rounded-lg hover:bg-[#1A4699] transition">
//             Sign up, It’s Free
//           </button>
//         </div>
//       </header>
//   );
// };

// export default Konn3ctHeader;
